import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

interface TagBadgeProps {
  name: string;
  color: string;
  onRemove?: () => void;
  className?: string;
}

export function TagBadge({ name, color, onRemove, className }: TagBadgeProps) {
  return (
    <Badge 
      variant="outline" 
      className={`gap-1 ${className}`}
      style={{ 
        borderColor: color,
        color: color,
        backgroundColor: `${color}15`
      }}
    >
      {name}
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-1 hover:bg-white/20 rounded-full p-0.5 transition"
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </Badge>
  );
}
